import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import { CursorDot } from "@/components/CursorDot";
import Portfolio from "@/pages/Portfolio";
import Admin from "@/pages/Admin";
import Article from "@/pages/Article";

const TOAST_OPTIONS = { style: { fontFamily: "'IBM Plex Mono', monospace", fontSize: "13px" } };

function App() {
  return (
    <BrowserRouter>
      <CursorDot />
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/writing/:slug" element={<Article />} />
        <Route path="/admin" element={<Admin />} />
      </Routes>
      <Toaster
        position="bottom-right"
        theme="light"
        toastOptions={TOAST_OPTIONS}
      />
    </BrowserRouter>
  );
}

export default App;
